import React from 'react';
import { connect } from 'react-redux';
import { updateWaitingAreaSmsNotification, resetWaitingAreaSmsNotificationForm } from '../../../../actions/waitingArea';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { displayGlobalMessage, hideGlobalMessage } from '../../../../actions/globalMessage';
import { updateShowCreateSmsNotificatioModal } from '../../../../actions/modal';
import objectAssign from 'object-assign';

@connect(mapStateToProps)
export default class RightPanelCreateSmsNotification extends React.Component {
  constructor(props, context) {
    super(props, context);
  }
  createWaitingAreaSmsNotification = (e) => {
    let areThereErrors = forceValidation(undefined, undefined, 'createWaitingAreaSmsNotificationForm');
    if (!areThereErrors && !window.$(e.target).hasClass('disable')) {
      console.log(!areThereErrors && !window.$(e.target).hasClass('disable'));
      let cb = () => {
        let show = false;
        this.props.dispatch(updateShowCreateSmsNotificatioModal(show));
        this.resetForm();
      };
      this.props.dispatch(
        updateWaitingAreaSmsNotification(this.props.waitingArea.id, this.props.waitingAreaSmsNotificationForm, cb)
      );
    }
  };

  cancelCreateWaitingAreaSmsNotification = () => {
    this.props.dispatch(hideGlobalMessage()); //in case there are errors on screen from previous failed actions
    let show = false;
    this.props.dispatch(updateShowCreateSmsNotificatioModal(show));
    this.resetForm();
  };

  resetForm = () => {
    this.props.dispatch(resetWaitingAreaSmsNotificationForm());
  };

  render() {
    let saveClasses =
      'ui labeled icon button icon color-button color-button-hover color-white  max-width left-text mrlnull mrbnull disable';
    return (
      <div className="ui actions mrbl max-width ">
        <button
          type="button"
          tabIndex="3"
          onClick={this.createWaitingAreaSmsNotification}
          data-group="createWaitingAreaSmsNotificationForm"
          className={this.props.waitingAreaSmsNotificationForm.updating ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark  icon" />
        </button>
        <button
          type="button"
          tabIndex="4"
          onClick={this.cancelCreateWaitingAreaSmsNotification}
          className="ui   labeled icon button color-bad-things color-bad-things-hover color-white    mrtm max-width left-text mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let selectedWaitingArea = state.waitingAreaReducer.cleanWaitingArea;
  if (!!state.waitingAreaReducer.selectedWaitingAreaId)
    selectedWaitingArea = state.waitingAreaReducer.waitingAreas.find(
      (wa) => wa.id === state.waitingAreaReducer.selectedWaitingAreaId
    );

  const waitingArea = objectAssign({}, state.waitingAreaReducer.cleanWaitingArea, selectedWaitingArea);
  return {
    waitingArea: waitingArea,
    waitingAreaSmsNotificationForm: state.waitingAreaReducer.waitingAreaSmsNotificationForm,
  };
}
